export enum DocumentType {
  TEXT, IMAGE, PDF
}
